import { Grid, Typography, styled } from "@mui/material";

import SearchInput from "components/SearchInput";
import useIsMobileView from "hooks/useIsMobileView";

function MarketHeader({ value, onChange }) {
  const isMobileView = useIsMobileView();

  return (
    <Grid container>
      <Grid item xs={12} mt={{ md: 6, xs: 2 }}>
        {isMobileView ? (
          <SearchInput value={value} onChange={onChange} />
        ) : (
          <>
            <Title component="h1">Market</Title>
          </>
        )}
      </Grid>
    </Grid>
  );
}

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: 700,
  color: theme.palette.text.main,
}));

export default MarketHeader;
